import React, {useState} from "react";
import {ModalDialogActionsComponent} from "../../modal-dialog/modal-dialog-actions.component";
import {DialogTextBox} from "../../modal-dialog/boxes/text/dialog-text.box";
import {GeoModalWrapperBox} from '../boxes/geo-modal-wrapper.box';
import {GeoDialogListBox} from "./boxes/geo-dialog-list.box";
import {GeoDialogListItemBox} from "./boxes/geo-dialog-list-item.box";
import {GeoDialogColoredTextBox} from "./boxes/geo-dialog-colored-text.box";
import {CyClass} from "../../../../common/cy-classes";
import {useServices} from "../../../react-hooks/use-services.hook";
import {observer} from "mobx-react";
import {GeoAnalyticsUserAction, IGeoLocationUserActionAnalytics} from "../../../services/geo-location/geo-location-analytics";

interface IGeoInstallPluginPopupComponentProps {
    downloadUrl: string;
    analytics: IGeoLocationUserActionAnalytics;
}

export const GeoInstallPluginPopupComponent: React.FC<IGeoInstallPluginPopupComponentProps> = observer((props) => {
    const services = useServices();
    const [downloadStarted, setDownloadStarted] = useState(false);

    const downloadPlugin = () => {
        setDownloadStarted(true);
        const a = document.createElement('a');
        a.href = props.downloadUrl;
        a.download = "player-location-check.exe";
        a.click();
    }

    const downloadButtonClick = () => {
        //services.analytics.sendOrbitUserFlowEvent('Client_Message', 'GeoInstallPluginPopupComponent', 'APPROVE');
        props.analytics.reportUserAction(GeoAnalyticsUserAction.DownloadPlugin);
        downloadPlugin();
    };

   const onFooterLinkClick = () => {
       //services.analytics.sendOrbitUserFlowEvent('Client_Message', 'GeoInstallPluginPopupComponent', 'DOWNLOAD_AGAIN');
       props.analytics.reportUserAction(GeoAnalyticsUserAction.ReDownloadPlugin);
       downloadPlugin();
    };

    return (
        <GeoModalWrapperBox className={CyClass('cy-modal-content')}>
            {<GeoDialogColoredTextBox>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_1")}</GeoDialogColoredTextBox>}
            {<DialogTextBox>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_2")}</DialogTextBox>}
            {<DialogTextBox>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_3")}</DialogTextBox>}
            {<GeoDialogColoredTextBox>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_4")}</GeoDialogColoredTextBox>}
            <GeoDialogListBox>
                <GeoDialogListItemBox itemPrefix='1'>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_BODY_1")}</GeoDialogListItemBox>
                <GeoDialogListItemBox itemPrefix='2'>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_BODY_2")}</GeoDialogListItemBox>
                <GeoDialogListItemBox itemPrefix='3' isLast = {true}>{services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_BODY_3")}</GeoDialogListItemBox>
            </GeoDialogListBox>

            <ModalDialogActionsComponent
                primaryAction={{
                    text: services.translation.translate("GEO_PLUGIN_DOWNLOAD_BUTTON"),
                    onClick: downloadButtonClick,
                    disabled: downloadStarted,
                    className: CyClass('cy-state-select-approve-button')
                }}
                linkAction = {{
                    text: downloadStarted ? services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_FOOTER") : "",
                    onClick: onFooterLinkClick,
                    className: CyClass('cy-modal-dialog-link')
                }}
            />
        </GeoModalWrapperBox>
    );
});
